import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-resource',
  templateUrl: './resource.component.html',
  styleUrls: ['./resource.component.scss']
})
export class ResourceComponent implements OnInit {
  @Input() thisResource;

  constructor() { }

  ngOnInit() {
  }

}
